import React from "react";
import "../HomePage.css";
import {
	Card,
	Grid,
	CardContent,
	Typography,
	CircularProgress,
} from "../../../common/MaterialComponent";
import { ErrorPage } from "../../ErrorPage/ErrorPage";
import { ButtonPrimary, primaryBorderColor } from "../../../common/sharedStyle";
import { useGetComponentStringsContext } from "../../../hooks/useGetComponentStrings";

interface HomePageLatestFeedsProps {
	latestFeeds?: string[];
	error?: string;
	displayLoadMoreButton: boolean;
	loadMore: () => Promise<void>;
}

export const HomePageFeeds: React.FC<HomePageLatestFeedsProps> = ({
	latestFeeds,
	error,
	displayLoadMoreButton,
	loadMore,
}) => {
	const strings = useGetComponentStringsContext().HomePage;
	return (
		<div>
			{error ? (
				<ErrorPage message={strings.errorMessage} />
			) : !latestFeeds ? (
				<div className="loader">
					<CircularProgress size={50} />
				</div>
			) : (
				<>
					<Card className="latestFeedCard" elevation={2}>
						<CardContent>
							<Grid container spacing={2}>
								<Grid item xs={12}>
									<Typography variant="h6" noWrap color="textSecondary">
										<b>{strings.latestFeedMessage}</b>
									</Typography>
								</Grid>
								<Grid item xs={12}>
									{latestFeeds.map((text) => (
										<Card
											className={"latestFeedItem " + primaryBorderColor}
											key={text}
											elevation={0}
										>
											<Typography
												component="div"
												className="latestFeedItemContent"
											>
												{text}
											</Typography>
										</Card>
									))}
								</Grid>
							</Grid>
							{displayLoadMoreButton ? (
								<ButtonPrimary onClick={loadMore}>
									{strings.loadMore}
								</ButtonPrimary>
							) : (
								<></>
							)}
						</CardContent>
					</Card>
				</>
			)}
		</div>
	);
};
